import {
  coreExtensionData,
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import { approvalApi } from './api/approvalApi';
import { ApproveAsRolePage } from './components/ApproveAsRolePage';
import { ApproveWithCodePage } from './components/ApproveWithCodePage';
import { TaskBanner } from './components/TaskBanner';

export const approvalGateScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    approvalApi,
    PageBlueprint.make({
      name: 'approve-as-role',
      params: {
        path: 'approve/:taskId',
        title: 'Approve as Role',
        loader: async () => <ApproveAsRolePage />,
      },
    }),
    PageBlueprint.make({
      name: 'approve-with-code',
      params: {
        path: 'approve/:taskId/withcode/:code',
        routeRef: undefined,
        loader: async () => <ApproveWithCodePage />,
      },
    }),
    scaffolderPlugin.getExtension('sub-page:scaffolder/tasks').override({
      factory(originalFactory) {
        const originalOutput = originalFactory();
        const originalElement = originalOutput.get(
          coreExtensionData.reactElement,
        );

        return [
          ...originalOutput,
          coreExtensionData.reactElement(
            <>
              <TaskBanner />
              {originalElement}
            </>,
          ),
        ];
      },
    }),
  ],
});
